export default "__VITE_ASSET__BROdF1yM__"